module.exports = __webpack_public_path__ + "img/img.b53196b7.png";